import { Breadcrumb, Tabs } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import WalletLayout from "../wallet-layout";
import { _adr } from "../../../address";
import "./walletList.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Content } from "antd/es/layout/layout";
import AgentWallet from "./agent-wallet";
import { Roles } from "../../../tools/services";

const WalletList = () => {
  const [t] = useTranslation("global");
  const [walletList, setWalletList] = useState([]);
  const [walletActive, setWalletActive] = useState("agentWallet");
  const { _currentUser } = useSelector((state) => state?.another);

  useEffect(() => {
    if (_currentUser) {
      let tabs = [
        {
          key: "agentWallet",
          label: "کیف پول نماینده",
        },
      ];
      if (_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessCP)) {
        if (_currentUser.hasOwnProperty("cpwalletamount")) {
          tabs.push({
            key: "packageWallet",
            label: "کیف پول بسته",
          });
        }
      }

      if (_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessCC)) {
        if (_currentUser.hasOwnProperty("ccwalletamount")) {
          tabs.push({
            key: "chargeWallet",
            label: "کیف پول شارژ",
          });
        }
      }

      setWalletList(tabs);
    }
  }, []);
  const handleChange = (item) => {
    setWalletActive(item);
  };
  return (
    <WalletLayout>
      <div className="g-hold-title-of-page">
        <Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("wallet.title") }]} />
        <div className="title-page">
          <h3>{t("wallet.title")}</h3>
          <p></p>
        </div>
        <div className="holder-tab">
          <Tabs
            onChange={handleChange}
            className="tab-wallet"
            items={walletList.map((item, key) => ({
              key: item.key,
              label: item.label,
            }))}
          ></Tabs>
        </div>
      </div>
      <div className="g-layout-content">
        <Content className="g-layout-main wa-container">
          <div className="holder-wallet-list">
            {walletActive === "agentWallet" && <AgentWallet type={1} wallet={_currentUser?.walletAmount} />}
            {walletActive === "packageWallet" && <AgentWallet type={2} wallet={_currentUser?.cpwalletamount} />}
            {_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessCC) && walletActive === "chargeWallet" && (
              <AgentWallet type={3} wallet={_currentUser?.ccwalletamount} />
            )}
          </div>
        </Content>
      </div>
    </WalletLayout>
  );
};

export default WalletList;
